import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import cn from 'classnames';
import style from "../common.module.scss"
import LineIcon from '../../../shared/icons/LineIcon';
import { getCountryIcon } from '../../../../utils/getCountryIcon';

const OrdersInfoDirections = ({ item, senderName = '', recipientName = '', isMarketplacePage = false }) => {
    const { t } = useTranslation(); // Initialize t function

    // Note: Date/time formatting might need more robust localization depending on requirements
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const optionsDate = { day: 'numeric', month: 'short' };
        const optionsWeekday = { weekday: 'short' };

        let formattedDate = date.toLocaleDateString('ru-RU', optionsDate);
        let formattedWeekday = date.toLocaleDateString('ru-RU', optionsWeekday);

        formattedDate = formattedDate.replace('.', '');
        formattedWeekday = formattedWeekday.replace('.', '');

        return `${formattedDate}, ${formattedWeekday}`;
    };

    const formatTime = (timeString) => {
        const date = new Date(timeString);
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    return (
        <div className={cn(style.shipping_wrapper)}>
            <LineIcon />
                <div className={cn(style.shipping_content, {
                    [style.shipping_content__twoColumns]: isMarketplacePage,
                })}>
                <div className={style.shipping_column}>
                    <span className={style.shipping_column_head}>{t('orderInfo.ordersInfoDirections.loadingLabel')}</span>
                    <div className={style.shipping_column_text}>
                        {formatDate(item?.shippingDate)}
                    </div>
                    <div className={style.shipping_column_footer}>
                        {t('orderInfo.ordersInfoDirections.timeFrom')} {formatTime(item?.shippingDate)} {t('orderInfo.ordersInfoDirections.timeTo')} {formatTime(item?.shippingDateEnd)}
                    </div>
                </div>
                <div className={style.shipping_column}>
                    <span className={style.shipping_column_head}>{t('orderInfo.ordersInfoDirections.fromLabel')}</span>
                    <div className={style.shipping_column_main}>
                        <img
                            src={getCountryIcon(item?.countryIdFrom)}
                            alt={t('orderInfo.ordersInfoAddressList.countryAlt')}
                            className={style.shipping_column_countryIcon}
                        />
                        <div className={style.shipping_column_text}>
                            {item?.cityFromName}
                        </div>
                    </div>
                    <div className={style.shipping_column_footer}>
                        {item?.addressFrom}
                    </div>
                </div>
                <div className={style.shipping_column}>
                    <span className={style.shipping_column_head}>{t('orderInfo.ordersInfoDirections.senderLabel')}</span>
                    <div className={style.shipping_column_text}>
                        {!isMarketplacePage && senderName}
                    </div>
                    <div className={style.shipping_column_footer}>
                        {!isMarketplacePage && recipientName} {/* Assuming this should be senderPhoneNumber? Check logic */}
                    </div>
                </div>
                <div className={style.shipping_column}>
                    <span className={style.shipping_column_head}>{t('orderInfo.ordersInfoDirections.unloadingLabel')}</span>
                    <span className={style.shipping_column_text}>
                        {formatDate(item?.unloadingDate)}
                    </span>
                    <span className={style.shipping_column_footer}>
                        {t('orderInfo.ordersInfoDirections.timeFrom')} {formatTime(item?.unloadingDate)} {t('orderInfo.ordersInfoDirections.timeTo')} {formatTime(item?.unloadingDateEnd)}
                    </span>
                </div>
                <div className={style.shipping_column}>
                    <span className={style.shipping_column_head}>{t('orderInfo.ordersInfoDirections.toLabel')}</span>
                    <span className={style.shipping_column_main}>
                        <img
                            src={getCountryIcon(item?.countryIdTo)}
                            alt={t('orderInfo.ordersInfoAddressList.countryAlt')}
                            className={style.shipping_column_countryIcon}
                        />
                        <div className={style.shipping_column_text}>
                            {item?.cityToName}
                        </div>
                    </span>
                    <span className={style.shipping_column_footer}>
                        {item?.addressTo}
                    </span>
                </div>
                {!isMarketplacePage && (
                    <div className={style.shipping_column}>
                        <span className={style.shipping_column_head}>{t('orderInfo.ordersInfoDirections.recipientLabel')}</span>
                        <span className={style.shipping_column_text}>
                            {!isMarketplacePage && recipientName}
                        </span>
                        <span className={style.shipping_column_footer}>
                            {!isMarketplacePage && senderName}
                        </span>
                    </div>
                )}

            </div>
        </div>
    );
};

export default OrdersInfoDirections;
